import { Container } from '@mantine/core';
import classes from './Footer.module.css';
import React from 'react';
function FooterSimple() {


    return (

        <div className={classes.footer}>
            <Container className={classes.inner} >
                © 2024 Fame.App, Optimized Creativity All rights reserved.
            </Container>

        </div>

    );
}

export default FooterSimple;
